import { LoadingOutlined } from '@ant-design/icons';
import { Spin as AntSpin } from 'antd';
import React, { memo } from 'react';

type SpinProps = {
  indicatorColor?: React.CSSProperties['color'];
  /** Pixel font size for `LoadingOutlined` */
  indicatorSize: number;
};

function Spin({ indicatorColor, indicatorSize }: SpinProps): JSX.Element {
  const indicator = (
    <LoadingOutlined
      spin
      style={{
        ...(indicatorColor !== undefined ? { color: indicatorColor } : {}),
        fontSize: indicatorSize
      }}
    />
  );
  // A class name is added to assist call sites that need to target the spin specifically.
  return <AntSpin className="Spin" indicator={indicator} />;
}

export default memo(Spin);
export type { SpinProps };
